// Libraries
import { FC } from "react";
import { Switch as RadixSwitch, SwitchThumb } from "@radix-ui/react-switch";

//  Types
import { SwitchProps, SwitchVariant } from "./Switch.types";

const VARIANT_CLASSES: Record<SwitchVariant, string> = {
  default: "border-border data-[state=checked]:gradient data-[state=unchecked]:bg-muted/60",
  muted:
    "border-border data-[state=checked]:border-hue-indigo/40 data-[state=checked]:bg-hue-indigo data-[state=unchecked]:bg-muted/60",
};

/** The knob pairs with the filled track; on the muted off track it stays white. */
const KNOB_CLASSES: Record<SwitchVariant, string> = {
  default: "",
  muted: "data-[state=checked]:bg-hue-indigo-foreground",
};

export const Switch: FC<SwitchProps> = ({ checked, onChange, variant = "default", disabled }) => {
  return (
    <RadixSwitch
      checked={checked}
      disabled={disabled}
      onCheckedChange={onChange}
      className={`w-[36px] h-[20px] rounded-full relative outline-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 ${VARIANT_CLASSES[variant]}`}
    >
      <SwitchThumb
        className={`block w-[12px] h-[12px] bg-white rounded-full absolute transition-left duration-100 -translate-y-1/2 -translate-x-1/2 left-2 will-change-left data-[state=checked]:left-[calc(100%_-_8px)] ${KNOB_CLASSES[variant]}`}
      />
    </RadixSwitch>
  );
};

export default Switch;
